import { SVGProps } from "react";

const Search = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1182 13L19.1182 19M8.11816 15C4.25217 15 1.11816 11.866 1.11816 8C1.11816 4.13401 4.25217 1 8.11816 1C11.9842 1 15.1182 4.13401 15.1182 8C15.1182 11.866 11.9842 15 8.11816 15Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Search;
